import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { PairCode } from '@era/locations-sdk';
import { EnvironmentService } from '@methylium/core';
import { GenerationType, QrCodeOptions, QrCodeComponent } from '@qr-code-lib';

@Component({
  selector: 'era-pairing-code-ui',
  templateUrl: './pairing-code.component.html',
  styleUrls: ['./pairing-code.component.scss'],
  imports: [QrCodeComponent, ReactiveFormsModule],
})
export class PairingCodeComponent implements OnChanges {
  @Input() code: PairCode;

  public codeChars: string[];
  public pairUrlWithCode: string;

  public pairUrl: string;

  public qrForeground = '#000000';
  public qrGenOptions: QrCodeOptions;

  public noQRCodeScanner = false;

  public formGroup: UntypedFormGroup;

  constructor(readonly environmentService: EnvironmentService) {
    this.qrForeground = this.environmentService.environment.locations.qrForeground;
    this.pairUrl = this.environmentService.environment.locations.pairUrl;

    this.qrGenOptions = {
      version: 5,
      type: GenerationType.Canvas,
      width: 150,
      margin: 0,
      color: {
        dark: this.qrForeground,
      },
    };

    if (this.environmentService.environment.local) {
      this.formGroup = new UntypedFormGroup({
        host: new UntypedFormControl('', Validators.required),
      });

      this.formGroup.controls.host.valueChanges.subscribe((host) => {
        const url = new URL(this.pairUrlWithCode);
        url.hostname = host;
        this.pairUrlWithCode = url.href;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.code) {
      this.codeChars = this.populateCodeChars(this.code.code);
      this.pairUrlWithCode = `${this.pairUrl}/${this.code.code}`;
    }
  }

  private populateCodeChars(code: string): string[] {
    if (!code) {
      return;
    }

    const chars: string[] = [];
    for (let x = 0; x < code.length; x++) {
      chars.push(code.charAt(x));
    }
    return chars;
  }
}
